(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/racing-game/components/statistics/assets/javascripts/statistics.js') >= 0) return;  svs.modules.push('/modules/racing-game/components/statistics/assets/javascripts/statistics.js');

'use strict';

const {
  browser
} = svs.components.Storage;
const {
  StatisticsView,
  HorseProfileList,
  HorseProfileSingle
} = svs.racing_game.components.statistics;
const {
  statistics
} = svs.racing_game.components;
const {
  navigation
} = svs.racing;
const {
  useEffect
} = React;
const {
  ReactIconButton
} = svs.ui;
const Icon = svs.ui.ReactIcon;
const isMobile = svs.core.detect.formfactor.mobile();
const Statistics = () => {
  const navState = navigation.useNavigationState();
  const [participants, selectedParticipant] = statistics.useParticipants(navState);
  const {
    toParticipant,
    toStatisticsItem
  } = navigation.useNavigationActions();
  useEffect(() => {
    if (!isMobile) {
      document.querySelector('.statistics-slider-panel').classList.add('statistics-slider-panel-open');
    }
  }, []);
  useEffect(() => {
    if (!browser.get('statisticsDisplayed', 'Racing')) {
      browser.set('statisticsDisplayed', 'Racing', true, svs.components.Storage.constants.EXPIRES_1YEAR);
    }
    window.scrollTo(0, 0);
  }, []);
  const goBack = () => {
    if (!isMobile) {
      document.querySelector('.statistics-slider-panel').classList.remove('statistics-slider-panel-open');
    }

    setTimeout(() => {
      toParticipant(undefined);
    }, 200);
  };
  const onGoBack = () => {
    document.querySelector('.statistics-holder').classList.add('statistics-holder-close');
    if (svs.components.revealAnimation.isRevertable()) {
      svs.components.revealAnimation.prepareRevertRevealAnimation(() => {
        svs.components.revealAnimation.revertRevealAnimation();
        goBack();
      });
    } else {
      goBack();
    }
  };
  return React.createElement("div", {
    className: "statistics-holder"
  }, !isMobile && React.createElement(React.Fragment, null, React.createElement(ReactIconButton, {
    className: "align-right padding-1",
    onClick: () => onGoBack()
  }, React.createElement(Icon, {
    className: "icon-close",
    color: "fc-navy",
    icon: "close",
    size: "200"
  })), React.createElement(HorseProfileSingle, {
    selectedParticipant: selectedParticipant
  })), isMobile && React.createElement("div", {
    className: "horse-profile-items-holder margin-xs-v-1"
  }, React.createElement(HorseProfileList, {
    participants: participants,
    selectedParticipant: selectedParticipant
  })), React.createElement("div", {
    className: "statistics-view-holder"
  }, React.createElement(StatisticsView, {
    onGoBack: () => onGoBack(),
    selectedMenuItem: navState.statisticsMenuItem,
    selectedParticipant: selectedParticipant,
    toStatisticsMenuItem: toStatisticsItem
  })));
};
svs.racing_game.components.statistics.Statistics = Statistics;

 })(window);